module.exports = __webpack_public_path__ + "img/e_2_2_g.d3d7f518.png";